import { render, staticRenderFns } from "./UploadPlatform.vue?vue&type=template&id=233b4b36&scoped=true&"
import script from "./UploadPlatform.vue?vue&type=script&lang=js&"
export * from "./UploadPlatform.vue?vue&type=script&lang=js&"
import style0 from "./UploadPlatform.vue?vue&type=style&index=0&id=233b4b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233b4b36",
  null
  
)

export default component.exports